<template>
  <div class="box white mb-3 p-3">
    <K2Row space-between="true">
      <K2Text bold="true" class-name="" :style="{ fontSize: uiVariable.fontSize.lg }">{{ lang('Tags') }}</K2Text>
      <K2Row>
        <div v-b-toggle="'tag'">
          <K2Icon color="black" name="expand_less" class="when-open" />
          <K2Icon color="black" name="expand_more" class="when-closed" />
        </div>
      </K2Row>
    </K2Row>
    <b-collapse id="tag" visible>
      <div>
        <K2Row>
          <!--<el-input :placeholder="lang('Please enter tags name')" v-model="feedCaption"-->
          <!--class="me-2"></el-input>-->
          <el-autocomplete
            class="inline-input"
            v-model="feedCaption"
            :fetch-suggestions="querySearch"
            :placeholder="lang('Please enter tags name')"
            @select="val => addCaption(val.value)"
          ></el-autocomplete>
          <K2Button @onclick="addCaption()" theme="2">{{ lang('Add') }}</K2Button>
        </K2Row>

        <div>
          <div v-if="arrobj_keyTag.length > 0" class="d-flex flex-wrap">
            <K2Row
              justify_content="center"
              align="center"
              v-for="(tag, i) in arrobj_keyTag"
              :key="i"
              class="tagItem box purple me-2 mt-2 rounded-pill px-2 py-1"
            >
              <div>
                <K2Text :color="uiVariable.color.purple">{{ tag.KeyTag }}</K2Text>
              </div>
              <K2Icon
                name="close"
                :font-size="uiVariable.fontSize.md"
                style="line-height: 14px; margin-left: auto"
                link="true"
                :color="uiVariable.color.purple"
                @onclick="removeItemAt(i)"
              />
            </K2Row>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import K2Icon from '../../../../uiComponents/k2Icon/k2MAIcon'
import K2Row from '../../../../uiComponents/k2Row/k2Row'
import uiVariable from '../../../../config/uiVariable'
import K2Button from '../../../../uiComponents/k2Button/k2Button'
import K2Text from '../../../../uiComponents/k2Text/k2Text'
import { lang } from '../../../../locale'
import DataSource from '../../../../data/datasource'

export default {
  name: 'activityTag',
  components: { K2Text, K2Button, K2Row, K2Icon },
  props: ['tpostkeytag'],
  watch: {
    tpostkeytag: function (value) {
      // watch it
      if (value) {
        this.handleUpdateTag(value)
      }
    },
  },
  data() {
    return {
      uiVariable: uiVariable,
      feedCaption: '',
      arrobj_keyTag: [],
      arrobj_keyTagList: [
        {
          prop: 'KeyTag',
          label: lang('Hashtag'),
        },
      ],
      arrobj_keyTagListAction: {
        label: lang('Delete'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.arrobj_keyTag.splice(this.arrobj_keyTag.indexOf(row), 1)
            },
            label: lang('Delete'),
          },
        ],
      },
      arrobj_latestPostTag: [],
    }
  },
  mounted() {
    this.init()
    const self = this
  },
  methods: {
    lang,
    init() {
      this.getLatestPostTag()
    },
    async getLatestPostTag() {
      try {
        const response = await DataSource.shared.getUserLatestGroupPostKeyTag(10)

        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getUserLatestGroupPostKeyTag Error')
          } else if (response.code === '2') {
            this.arrobj_latestPostTag = []
          } else {
            let latestTag = []

            response.Table.forEach(d => {
              latestTag.push({ value: d.PostKeyTagValue })
            })
            this.arrobj_latestPostTag = latestTag
          }
        }
      } catch (e) {
        // this.results = e;
        console.log(e, 'latest post tag error!')
      }
    },
    querySearch(queryString, cb) {
      let links = this.arrobj_latestPostTag
      // call callback function to return suggestions
      cb(links)
    },
    showLoading() {
      this.$vs.loading()
    },

    hideLoading() {
      this.$vs.loading.close()
    },
    checkArray(list) {
      return Array.isArray(list)
    },
    handleUpdateTag(value) {
      if (this.checkArray(value)) {
        value.forEach(d => {
          this.arrobj_keyTag.push({ KeyTag: d })
        })
      } else {
        this.arrobj_keyTag.push({ KeyTag: value })
      }
      this.$emit('keytags', this.arrobj_keyTag)
    },
    addCaption() {
      if (this.feedCaption !== '') {
        const tagArray = this.feedCaption.split(',')
        tagArray.forEach((d, i) => {
          let temp = {}
          temp.KeyTag = d
          this.arrobj_keyTag.push(temp)
        })
        // let objKeyTag = {};
        // objKeyTag.KeyTag = this.feedCaption;
        this.$emit('keytags', this.arrobj_keyTag)
        this.feedCaption = ''
        this.$forceUpdate()
      }
    },
    addCaptionByLatest(val) {
      var objKeyTag = {}
      objKeyTag.KeyTag = val
      this.arrobj_keyTag.push(objKeyTag)
    },
    removeItemAt(index) {
      this.arrobj_keyTag.splice(index, 1)
      this.$emit('keytags', this.arrobj_keyTag)
    },
  },
}
</script>
